import { ref, watch, nextTick, onMounted } from 'vue'
import { isUndefined } from 'lodash-es'
import { onKeyStroke } from '@vueuse/core'
import { useZIndex } from '../../hooks/useZIndex'
import { dialogController, EVENT_CODE_ESC } from './dialog'
import { kkLockBodyScroll, kkUnlockBodyScroll } from '../../libraries'
import { useModel } from '../../hooks/useModel';

export default function useDialog(props, emits, targetRef) {
	let uuid = null

	const { model: visible } = useModel(props, emits);
	const { nextZIndex } = useZIndex()

	const rendered = ref(false)
	const zIndex = ref(props.zIndex ?? nextZIndex())

	watch(
		() => visible.value,
		(val) => {
			if (val) {
				open()
				rendered.value = true // enables lazy rendering
				zIndex.value = isUndefined(props.zIndex)
					? nextZIndex()
					: zIndex.value++

				nextTick(() => {
					emits('open')

					if (targetRef.value?.dialogBodyRef) {
						targetRef.value.dialogBodyRef.scrollTop = 0
					}
				})
			} else {
				close()
			}
		},
	)

	// 按下 esc 關閉 dialog
	onKeyStroke(EVENT_CODE_ESC, () => {
		const { lastUuid, doClose } = dialogController.getLastDialog()

		if (visible.value && props.closeOnPressEscape && lastUuid === uuid) {
			doClose?.()
		}
	})

	// 點擊遮罩關閉 dialog
	function onModalClick() {
		if (props.closeOnClickModal) {
			doClose()
		}
	}

	function afterEnter() {
		emits('opened')
	}

	function beforeLeave() {
		emits('close')
	}

	function afterLeave() {
		emits('closed')

		if (props.destroyOnClose) {
			rendered.value = false
		}
	}

	function open() {
		uuid = dialogController.add({ doClose })

		kkLockBodyScroll()
	}
	function doOpen() {
		visible.value = true
	}

	function close() {
		dialogController.remove(uuid)

		if (dialogController.getSize() <= 0) {
			kkUnlockBodyScroll()
		}
	}
	function doClose() {
		visible.value = false
	}

	onMounted(() => {
		if (visible.value) {
			rendered.value = true

			open()
		}
	})

	return {
		visible,
		zIndex,
		rendered,
		doOpen,
		doClose,
		beforeLeave,
		afterLeave,
		afterEnter,
		onModalClick,
	}
}
